(ns dashboard.components.navbar
  (:require [clojure.string]
            [re-frame.core :as rf]
            [reitit.frontend.easy :as rfe]
            [dashboard.subs :as subs]
            [dashboard.ui :as ui]
            [dashboard.browser-extension :as browser-extension]
            [dashboard.components.search.events :as search-events]))

(defn navitem
  "
  Given route from routes. Return a navbar component with rfe/href anchor.
  Or dropdown menu with navlinks
  "
  [index route]
  (let [[_ config] route
        label      (-> config :navbar :label)
        title      (-> config :navbar :title)
        dropdown   (-> config :navbar :dropdown)
        dropdown?  (some? dropdown)
        view-name  (:name config)]
    ;; TODO: eval if better to be divided to individual components
    (if dropdown?
      ;; Item with dropdown menu
      [:div.navbar-item.has-dropdown.is-hoverable
       {:key index}
       [:a.navbar-link label]
       [:div.navbar-dropdown (map-indexed #(navitem %1 [nil %2]) dropdown)]]
      ;; Nav link
      [:a.navbar-item.has-text-link
       {:key      index
        :href     (rfe/href view-name)
        :on-click #(rf/dispatch [::ui/close-menu])
        :title    title}
       label])))

(defn navitem-position [route]
  (-> route second :navbar :position))

(defn navitem-left? [route]
  (= :left (-> route navitem-position)))

(defn navitem-right? [route]
  (= :right (-> route navitem-position)))

(defn route-allowed-by-acl?
  [[_path {:keys [acl]}] {:keys [roles]}]
  (boolean (some roles acl)))

(defn route-allowed-by-feature? [[_path {:keys [needs-some-feature]}] {:keys [features_enabled] :as _user}]
  (if needs-some-feature
    (boolean (some needs-some-feature features_enabled))
    ;; Allow by default
    true))

(defn navbar
  "Navigation bar component, showing the top-level navigation items, based on the routes that the user can access."
  [routes]
  (let [user           @(rf/subscribe [::subs/user])
        show-menu?     @(rf/subscribe [::subs/ui.show-menu?])
        allowed-routes (filter #(and (route-allowed-by-acl? % user)
                                     (route-allowed-by-feature? % user))
                               routes)
        nav-left       (filter navitem-left? allowed-routes)
        nav-right      (filter navitem-right? allowed-routes)
        navbar-menu-class [(when show-menu?
                             "is-active")]
        mode           (get-in @(rf/subscribe [::subs/route])
                               [:parameters :query :mode])
        extension-path? (browser-extension/is-browser-extension-path?)
        is-extension-expanded @(browser-extension/is-extension-expanded)
        is-embedded?   (or (= mode "embed") extension-path?)
        structured-analysis-creation-enabled? @(rf/subscribe [::subs/feature-enabled :structured-analysis-creation])]
    [:<>
     [:nav.navbar.is-fixed-top.has-shadow.has-text-weight-bold
      {:style (cond-> {:z-index 1000}
                is-embedded? (assoc :display "flex"
                                    :justify-content "center"))
       :class (when structured-analysis-creation-enabled? "administration-mode")
       :role "navigation"
       :aria-label "main-navigation"}
      (when (or (not is-embedded?)
                (true? is-extension-expanded))
        [;; navbar logo and burger menu
         :h1.navbar-brand
         (when-not is-embedded?
           [;; logo
            :a.navbar-item (when-not is-embedded?
                             {:href (rfe/href :route.view/home)})
            [:img {:src "/img/repliance-logo.svg" :width "auto" :height 45 :alt "Repliance"}]])

         (when-not is-embedded?
           [;; burger
            :a.navbar-burger {:on-click #(rf/dispatch [::ui/toggle-menu])
                              :class    [(when show-menu?
                                           "is-active")]
                              :role "button"
                              :aria-label "menu"}
            [:span {:aria-hidden "true"}]
            [:span {:aria-hidden "true"}]
            [:span {:aria-hidden "true"}]])])

      (when is-embedded?
        [:div.level.is-flex-grow-1.is-flex.my-1
         (when is-extension-expanded
          [:div
          [:a.navbar-item (when-not is-embedded?
                            {:href (rfe/href :route.view/home)})
           [:img {:src "/img/repliance-logo.svg" :height 45 :alt "Repliance"}]]])
         [:div
          (when is-extension-expanded
            [:<>
             [:button.button.is-tertiary.is-align-self-center.is-small.mr-2.my-1
              {:title "Refresh this page"
               :on-click #(.reload (.-location js/window))}
              [:span.icon>i.fas.fa-refresh]]
             [:button.button.is-tertiary.is-align-self-center.is-small.mr-6.my-1
              {:title "Open search"
               :on-click #(rf/dispatch [::search-events/set-search-visible true])}
              [:span.icon>i.fas.fa-magnifying-glass]]])

          [:button.button.is-small.mx-2.my-1
           {:class (if is-extension-expanded :is-tertiary :is-primary)
            :on-click #(browser-extension/toggle-extension-expanded
                        (not is-extension-expanded))}
           (if is-extension-expanded
             [:i.icon.fas.fa-minimize]
             [:i.icon.fas.fa-maximize])]]])

      (when-not is-embedded?
        [:div.navbar-menu.navbar-start {:class navbar-menu-class}
         (map-indexed navitem nav-left)])
      [:div.navbar-menu.navbar-end {:class navbar-menu-class}
       [:div.navbar-item
        (if structured-analysis-creation-enabled?
          [:div.tag.is-small.is-success {:class navbar-menu-class} "Administrative Mode"]
          [:div.tag.is-small {:class navbar-menu-class} js/window.location.hostname])]
       (when-not (or (contains? (:roles user) "anonymous")
                     structured-analysis-creation-enabled?)
         [:button.button.navbar-item.has-text-link.is-nav-search.is-align-self-center
          {:href "#"
           :title "Open search"
           :on-click #(rf/dispatch [::search-events/set-search-visible true])}
          "Search" [:span.icon.mr-0>i.fas.fa-magnifying-glass]])
       (map-indexed navitem nav-right)]]]))
